// extracted by mini-css-extract-plugin
export var dark = "s_sp";
export var darkcookie = "s_sq";
export var tintedcookie = "s_sr";
export var regularcookie = "s_ss";
export var darkbase = "s_st";
export var tintedbase = "s_sv";
export var regularbase = "s_sw";
export var darkraw = "s_sx";
export var tintedraw = "s_sy";
export var regularraw = "s_sz";
export var darkchick = "s_sB";
export var tintedchick = "s_sC";
export var regularchick = "s_sD";
export var darkherbarium = "s_sF";
export var tintedherbarium = "s_sG";
export var regularherbarium = "s_sH";
export var darkholiday = "s_sJ";
export var tintedholiday = "s_sK";
export var regularholiday = "s_sL";
export var darkoffline = "s_sM";
export var tintedoffline = "s_sN";
export var regularoffline = "s_sP";
export var darkorchid = "s_sQ";
export var tintedorchid = "s_sR";
export var regularorchid = "s_sS";
export var darkpro = "s_sT";
export var tintedpro = "s_sV";
export var regularpro = "s_sW";
export var darkrose = "s_sX";
export var tintedrose = "s_sY";
export var regularrose = "s_sZ";
export var darktimes = "s_s0";
export var tintedtimes = "s_s1";
export var regulartimes = "s_s2";
export var darkwagon = "s_s3";
export var tintedwagon = "s_s4";
export var regularwagon = "s_s5";